/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import { account_service } from '../../services/account_service';
import "./header.css"
const HeaderCompany = () => {
  const navigate = useNavigate();

  // navigation 
  // navigation 
  const profil = () => {
    navigate('/company/profil');
  };

  const home = () => {
    navigate('/company/dashboad');
  };


  // sweet alert of deconnexion 
  const handleLogoutCompany = () => {
    swal({
      title: "Déconnection!",
      text: "Êtes-vous sûr de vouloir vous déconnecter ?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          account_service.logoutCompany()
          localStorage.removeItem('nom')
          navigate("/auth/loginCompany");
          // swal("Vous avez été déconnecter!", {
          //   icon: "success",
          // });
        } else {
          return;
        }
      });
  };

  // get name of connected company 
  const nom = localStorage.getItem("nom")
  return (
    <div>
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        {/* Left navbar links */}
        <ul className="navbar-nav ">
          <li className="nav-item hide-item">
            <a className="nav-link" data-widget="pushmenu" href="#"><i className="fas fa-bars" /></a>
          </li>
          <li className="nav-item">
            <a title='Voir mon profil' onClick={profil} className="nav-link link">Profil</a>
          </li>
        </ul>

        {/* <ul className="navbar-nav">
          <a onClick={profil} className="d-block link"><strong>{nom}</strong></a>
        </ul> */}
        <ul className="navbar-nav ml-auto">
          <a className='deconnexion px-2 py-2 text-white badge badge-success btn-deconnection' title='Cliquez pour ce déconnecter' onClick={handleLogoutCompany}>
            <i class="fas fa-sign-out-alt mr-1"></i>Déconnexion
          </a>
        </ul>
      </nav>
    </div>
  );
};

export default HeaderCompany;